/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import moment from 'moment';
import { apiConfig } from '@pages/ActualDetailPage/config/api.config';
import { transactionActualDetailConfig } from '../../config/transactionReceipt.config';
import { GET_TRANSACTION_DETAIL } from '@pages/ActualDetailPage/api/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';
const lookup = require('country-code-lookup');

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IBlockchainTransactionPluginMethods extends IPluginMethodMap {
  getBlockchainTransaction(args?: any): Promise<any>;
}

export class BlockchainTransactionPlugin implements IAgentPlugin {
  readonly methods: IBlockchainTransactionPluginMethods;

  constructor() {
    this.methods = {
      getBlockchainTransaction: this.getBlockchainTransaction.bind(this),
    };
  }

  async getBlockchainTransaction(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));

    //return await this.props(args);
    return { ...transactionActualDetailConfig };
  }
  //Graphql Query example
  async props(args?: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = null;
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_TRANSACTION_DETAIL, {
          input: {
            hash: args?.data?.find((item: any) => item?.id === args?.cardId)
              ?.payload?.hash,
          },
        })
        .toPromise();

      if (res?.data?.getBlockchianTxn) {
        console.log(`transaction details`, res?.data?.getBlockchianTxn);
        let _result = res?.data?.getBlockchianTxn;
        // return _result;
        return {
          heroImage: transactionActualDetailConfig?.heroImage,
          buttons: [
            {
              ...transactionActualDetailConfig?.buttons,
              link: _result?.txnLink,
            },
          ],
          listItems: this.getListItems(_result),
          carouselItems: this.getCarouselItems(_result),
        };
      }
    } catch (err: any) {
      // log.log('result of capsules=', res?.data?.capsules);
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }

  private getCarouselItems(result: any) {
    let _temp = [];
    _temp.push({
      type: 'qr',
      src: result?.txnLink,
    });

    return _temp;
  }

  private getListItems(res: any) {
    let _temp = transactionActualDetailConfig?.listItems?.map((ele: any) => {
      if (ele?.key === 'from') {
        return {
          ...ele,
          subTitle: res?.from ?? '-',
        };
      }
      if (ele?.key === 'status') {
        return {
          ...ele,
          subTitle: res?.status ?? '-',
        };
      }
      if (ele?.key === 'transactionHash') {
        return {
          ...ele,
          subTitle: res?.hash ?? '-',
        };
      }
      if (ele?.key === 'timestamp') {
        return {
          ...ele,
          subTitle: moment(res?.timestamp).format('LLL') ?? '-',
        };
      }
      if (ele?.key === 'interactedWith') {
        return {
          ...ele,
          subTitle: res?.to ?? '-',
        };
      }
      if (ele?.key === 'value') {
        return {
          ...ele,
          subTitle: res?.value !== '0' ? res?.value : '-',
        };
      }
      if (ele?.key === 'transactionId') {
        return {
          ...ele,
          subTitle: res?.txnId ?? '-',
        };
      }
    });

    return _temp;
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
